import { useEffect, useState } from "react"
import {
   SelectionType,
   YoungOrGroupSelectorDialog,
} from "@/components/dialog/YoungOrGroupSelectorDialog"
import { IndividualAttendanceMiniCalendar } from "@/components/attendance/IndividualAttendanceMiniCalendar"
import { PieChartAttendance } from "@/components/attendance/PieChartAttendance"
import { SchoolPeriod } from "@/entities/schoolYear/SchoolPeriod"
import { useAllSchoolPeriods } from "@/hooks/findAllSchoolPeriods"
import { useCurrentSchoolYear } from "@/entities/schoolYear/useSchoolYear"
import { SchoolPeriodSelector } from "@/components/filters/SchoolPeriodSelector"
import { useParams } from "react-router-dom"
import { useUser } from "@/entities/user/useUser"
import { UserSmallProfile } from "@/components/ui/UserSmallProfile"
import { icon_edit } from "@/utils/svgIcons"

export default function StatistiquesPage() {
   const { opt_id } = useParams()
   const { data: young } = useUser({ id: opt_id })

   const [showSelector, setShowSelector] = useState(opt_id === undefined)
   const { data: schoolYear } = useCurrentSchoolYear()
   const allSchoolPeriods = useAllSchoolPeriods(schoolYear)

   const [selection, setSelection] = useState<SelectionType | null>(null)
   const [selectedPeriod, setSelectedPeriod] = useState<SchoolPeriod | null>(null)

   useEffect(() => {
      if (young) {
         setSelection({ type: "young", young })
      }
   }, [young])

   const handleSelect = (newSelection: SelectionType) => {
      setSelection(newSelection)
      setShowSelector(false)
   }

   return (
      <div className="page-section">
         <h1 className="title">Statistiques</h1>

         <div className="filter-bar p-3 flex items-center justify-center gap-8 mb-6">
            {!selection && ("Pas de sélection")}
            {selection && selection.type === "young" && <UserSmallProfile user={selection.young} clickToGoToResume />}
            {selection && selection.type === "group" && <span className="font-bold">{selection.name}</span>}
            <button className="btn " onClick={() => setShowSelector(true)}>
               {icon_edit}
            </button>
         </div>

         {showSelector && (
            <YoungOrGroupSelectorDialog
               onSelect={handleSelect}
               onClose={() => setShowSelector(false)}
            />
         )}

         {!!selection && (
            <div role="tablist" className="tabs tabs-sm md:tabs-lg tabs-lifted">
               {/* ********************************************************** */}


               <input
                  type="radio"
                  name="stats_tabs"
                  role="tab"
                  className="tab h-full"
                  aria-label="Période"
                  defaultChecked
               />
               <div
                  role="tabpanel"
                  className="tab-content bg-base-100 border-base-300 rounded-box p-6"
               >
                  <SchoolPeriodSelector setSelectedSchoolPeriod={setSelectedPeriod} />

                  {!!selectedPeriod && (
                     <PieChartAttendance
                        period={{
                           from: selectedPeriod?.start_date,
                           to: selectedPeriod?.end_date,
                        }}
                        youngs={selection.type === "group" ? selection.youngs : [selection.young]}
                        hidePeriod={true}
                     />
                  )}
               </div>
               {/* ********************************************************** */}

               <input
                  type="radio"
                  name="stats_tabs"
                  role="tab"
                  className="tab h-full md:min-w-[12rem]"
                  aria-label="Toutes périodes"
               />
               <div
                  role="tabpanel"
                  className="tab-content bg-base-100 border-base-300 rounded-box p-6"
               >
                  <div className="flex flex-col xl:flex-row md:justify-around">
                     {!!allSchoolPeriods &&
                        allSchoolPeriods.map((period, index) => (
                           <div key={"all-school-periods-" + index} className="mb-6 w-full">
                              <PieChartAttendance
                                 key={"all-school-periods-" + index}
                                 period={{
                                    from: period.start_date,
                                    to: period.end_date,
                                 }}
                                 youngs={
                                    selection.type === "group"
                                       ? selection.youngs
                                       : [selection.young]
                                 }
                              />
                              <hr className="xl:hidden my-4" />
                           </div>
                        ))}
                  </div>
               </div>
               {/* ********************************************************** */}
               <input
                  type="radio"
                  name="stats_tabs"
                  role="tab"
                  className="tab h-full"
                  aria-label="Année"
               />
               <div
                  role="tabpanel"
                  className="tab-content bg-base-100 border-base-300 rounded-box p-6"
               >
                  {!!schoolYear && (
                     <PieChartAttendance
                        period={{
                           from: schoolYear.start_date,
                           to: schoolYear.end_date,
                        }}
                        youngs={selection.type === "group" ? selection.youngs : [selection.young]}
                     />
                  )}
               </div>
               {/* ********************************************************** */}

               <input
                  type="radio"
                  name="stats_tabs"
                  role="tab"
                  className="tab h-full"
                  aria-label="Calendrier individuel"
                  
               />
               <div
                  role="tabpanel"
                  className="tab-content bg-base-100 border-base-300 rounded-box p-6"
               >
                  {selection.type === "young" && (
                     <IndividualAttendanceMiniCalendar youngId={selection.young.id} />
                  )}

                  {selection.type === "group" && (
                     <div className="alert shadow-lg">
                        <div className="flex flex-row gap-2 items-center">
                           <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="stroke-current flex-shrink-0 h-6 w-6"
                              fill="none"
                              viewBox="0 0 24 24"
                           >
                              <path
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                                 strokeWidth="2"
                                 d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                              />
                           </svg>
                           <span>Le calendrier individuel est indisponible pour les groupes</span>
                        </div>
                     </div>
                  )}
               </div>
               {/* ********************************************************** */}

            </div>
         )}
      </div>
   )
}
